/**
 * Pathless layout route wrapped around every organisation-gated page in
 * router.tsx. If the current URL matches a page that an admin has blocked for
 * the user's organisation(s) (`dashboard_org_pages`, effect = block), it
 * renders the "page not available" view instead of the page.
 *
 * The backend enforces the same block on the page's API paths, so this is
 * UX, not the security boundary.
 */
import { Outlet, matchPath, useLocation } from 'react-router-dom'
import PageBlocked from '../containers/pageBlocked'
import { usePageAccess } from './pageAccess'

export const PageGuard = () => {
    const { pathname } = useLocation()
    const { blockedPages } = usePageAccess()
    const blocked = blockedPages.some((path) => matchPath({ path, end: true }, pathname))
    return blocked ? <PageBlocked /> : <Outlet />
}

export default PageGuard
